import { RRule } from 'rrule';

import { type Booking, localInput, localInstant } from './calendar';

export function repeatBookings(
  booking: Booking,
  frequency: 'daily' | 'weekly' | 'monthly' | 'yearly',
  interval: number,
  count: number,
  zone: string,
  occurrence: '' | 'earlier' | 'later' = '',
) {
  if (
    !Number.isInteger(count) ||
    count < 1 ||
    count > 366 ||
    !Number.isInteger(interval) ||
    interval < 1 ||
    interval > 52
  ) {
    throw new Error('Use 1–366 occurrences and an interval of 1–52.');
  }

  const local = localInput(booking.startsAt, zone),
    duration = Date.parse(booking.endsAt) - Date.parse(booking.startsAt),
    seriesId = crypto.randomUUID();

  // RRule expands floating calendar fields. Temporal maps each result into the
  // selected timezone and rejects nonexistent local clock times.
  const rule = new RRule({
    freq: {
      daily: RRule.DAILY,
      weekly: RRule.WEEKLY,
      monthly: RRule.MONTHLY,
      yearly: RRule.YEARLY,
    }[frequency],
    interval,
    count,
    dtstart: new Date(`${local}:00Z`),
  });

  return rule.all().map((date, index) => {
    const startsAt = localInstant(date.toISOString().slice(0, 16), occurrence, zone);

    return {
      ...booking,
      startsAt,
      endsAt: new Date(Date.parse(startsAt) + duration).toISOString(),
      zone,
      recurrence: { seriesId, frequency, interval, count, index, originalStartsAt: startsAt, zone },
    };
  });
}
